import React from 'react'
import { Badge, Button, Image, View } from '@aws-amplify/ui-react'
import { useNavigate } from 'react-router-dom'
import { useComponentSize } from '../ResponsiveSize'


export function Logo() {
    const navigate = useNavigate()
    const componentSize = useComponentSize()

    return (
        <View>
            <Button variation='menu' onClick={() => navigate('/')}>
                <Image
                    alt="MyTmpVpn logo"
                    src="/mytmpvpn-website-favicon-black.png"
                    height="2em"
                    width="2em"
                />
                {componentSize === 'standard' && <>MyTmpVpn<Badge variation='warning' size='small' marginLeft={'0.3em'}>Beta</Badge></>}
            </Button>
        </View>
    )
}